export default "__VITE_ASSET__DtImHuhe__"